import router from "./router";
import i18n from "./i18n";

export const eventsModuleRouter = router;
export const eventsModuleI18n = i18n;
